import React, { useEffect, useMemo, useState } from "react";
import { campaignListRequestApi } from "../../store/saga/requests/campaignRequests";
import {
  Table as ReactTable,
  useReactTable,
  getCoreRowModel,
  flexRender,
  ColumnDef,
} from "@tanstack/react-table";
import { ICampaignListTypes } from "../../types/campaignTypes";
import ReactPaginate from "react-paginate";
import { ITablePagination } from "../../types/commonTypes";
import { pageSizes } from "../../utils/utils";

import { Tooltip } from "@mui/material";
import moment from "moment";
import { ChevronLeft, ChevronRight, MoreHorizontal } from "lucide-react";
import { NavLink } from "react-router-dom";

export default function AgentCampaigns() {
  const [campaignList, setCampaignList] = useState<ICampaignListTypes[]>([]);
  const [paginationMetaData, setPaginationMetaData] = useState({
    take: pageSizes[0].value,
    skip: 0,
  });
  const [pageCount, setPageCount] = useState<number>(0);
  useEffect(() => {
    getData(paginationMetaData);
  }, [paginationMetaData]);
  const columns = useMemo<ColumnDef<ICampaignListTypes>[]>(
    () => [
      {
        accessorKey: "name",
        cell: (info) => (
          <NavLink to={`${info.row.original.campaignId}`}>
            <span className="tb-link">
              {info.row.original.name}
            </span>
          </NavLink>
        ),
        header: "Campaign Name",
      },
      {
        accessorKey: "startDate",
        cell: (info) =>
          moment(info.row.original.startDate).format("DD/MM/YYYY"),
        header: "Start Date",
      },
      {
        accessorKey: "endDate",
        cell: (info) => moment(info.row.original.endDate).format("DD/MM/YYYY"),
        header: "End Date",
      },
      {
        accessorKey: "total",
        header: "Total",
      },
      {
        accessorKey: "remarks",
        cell: (info) => (
          <div className="flex justify-center gap-1 items-end ">
            {info.row.original.remarks.substring(0, 16)}{" "}
            {info.row.original.remarks.length > 16 && (
              <Tooltip
                title={info.row.original.remarks}
                className="cursor-pointer"
              >
                <MoreHorizontal size={15} />
              </Tooltip>
            )}
          </div>
        ),
        header: "Remarks",
      },
    ],
    [campaignList]
  );
  async function getData(data: any) {
    campaignListRequestApi(data).then((response) => {
      setCampaignList(response.data.data);
      setPageCount(response.data.paginationMetaData.count);
      console.log(response.data);
    });
  }
  const handlePageClick = (data: any) => {
    console.log(data.selected);
    const skip = data.selected * paginationMetaData.take;
    const newPagination: ITablePagination = {
      ...paginationMetaData,
      skip,
    };
    setPaginationMetaData(newPagination);
  };
  const data = useMemo(() => campaignList, [campaignList]);
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    // getFilteredRowModel: getFilteredRowModel(),
    // getPaginationRowModel: getPaginationRowModel(),
    debugTable: false,
    manualPagination: true,
    // pageCount: customerListPageCount
    //   ? Math.ceil(customerListPageCount / pageSize)
    //   : undefined,
    // state: {
    //   pagination,
    // },
    // onPaginationChange: setPagination,
  });
  return (
    <div>
      <span className="page-title">Assigned Campaigns - Dedicated</span>
      <section className="bg-white p-5 rounded mt-4">
        <div className="table-wrapper">
          <table className="p-2 w-full ">
            <thead className="w-full bg-primary table-head-sticky">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id} className="">
                  {headerGroup.headers.map((header) => (
                    <th key={header.id} className="tb-head">
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header?.toString(),
                            header.getContext()
                          )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody className="">
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id} className="tb-row">
                  {row.getVisibleCells().map((cell) => (
                    <td key={cell.id} className="tb-data  ">
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end mt-2 gap-3">
          <ReactPaginate
            previousClassName="pagination-pre-btn"
            nextClassName="pagination-next-btn"
            previousLabel={<ChevronLeft size={20} className=" text-black" />}
            nextLabel={<ChevronRight size={20} className=" text-black" />}
            breakLabel="..."
            breakClassName={"break-me"}
            pageCount={pageCount / paginationMetaData.take}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName="pagination"
            disabledClassName=""
            activeClassName="pagination-active-btn"
            pageClassName="pagination-inactive-btn"
          />
          <select
            className="p-2"
            onChange={(e) => {
              const newPagination: ITablePagination = {
                ...paginationMetaData,
                take: Number(e.target.value),
              };
              setPaginationMetaData(newPagination);
            }}
          >
            {pageSizes.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
      </section>
    </div>
  );
}
